export const isSuccessStatusCode = (statusCode: number) => {
  return statusCode >= 200 && statusCode < 300;
};

export const isRedirectStatusCode = (statusCode: number) => {
  return statusCode >= 300 && statusCode < 400;
};

export const isClientErrorStatusCode = (statusCode: number) => {
  return statusCode >= 400 && statusCode < 500;
};

export const isServerErrorStatusCode = (statusCode: number) => {
  return statusCode >= 500 && statusCode < 600;
};
